export default __webpack_public_path__ + "static/women6-4498a115c47de0ebad82e0f1f04589f8.webp";